"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _KnowledgeCss = _interopRequireDefault(require("./Knowledge.css.js"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TypeColumn = function TypeColumn(_ref) {
  var title = _ref.title,
      children = _ref.children,
      styleOverride = _ref.styleOverride;
  var fullColumnTitleStyle = Object.assign({}, _KnowledgeCss.default['typeColumnTitle'], styleOverride['typeColumnTitle']);
  return /*#__PURE__*/_react.default.createElement("div", {
    key: "".concat(title, "-info-column"),
    style: _KnowledgeCss.default.typeColumn
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: fullColumnTitleStyle
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    style: _KnowledgeCss.default.typeColumnContent
  }, children));
};

var _default = (0, _radium.default)(TypeColumn);

exports.default = _default;

//# sourceMappingURL=TypeColumn.jsx.map